import React from 'react';
import {
  FaFacebook, FaInstagram, FaTiktok,
  FaGoogle, FaSnapchatGhost, FaLinkedin,
} from 'react-icons/fa';

const PLATFORMS = [
  { value: 'Facebook',  label: 'Meta (Facebook)', icon: <FaFacebook  className="text-3xl" />, color: '#1877f2' },
  { value: 'Instagram', label: 'Instagram',        icon: <FaInstagram className="text-3xl" />, color: '#e1306c' },
  { value: 'TikTok',   label: 'TikTok',            icon: <FaTiktok    className="text-3xl" />, color: '#ff0050' },
  { value: 'Google',   label: 'Google Ads',         icon: <FaGoogle    className="text-3xl" />, color: '#ea4335' },
  { value: 'Snapchat', label: 'Snapchat',           icon: <FaSnapchatGhost className="text-3xl" />, color: '#f5a623' },
  { value: 'LinkedIn', label: 'LinkedIn',           icon: <FaLinkedin  className="text-3xl" />, color: '#0a66c2' },
];

const PlatformSelector = ({ selected, onSelect }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
    {PLATFORMS.map((p) => {
      const isSelected = selected === p.value;
      return (
        <button
          key={p.value}
          type="button"
          onClick={() => onSelect(p.value)}
          className={`flex flex-col items-center justify-center gap-3 p-5 rounded-2xl border-2 transition-all ${
            isSelected
              ? 'border-[#221C51] bg-[#221C51]/5 shadow-md scale-105'
              : 'border-gray-200 bg-gray-50 hover:border-gray-300 hover:shadow-sm'
          }`}
        >
          <span style={{ color: p.color }}>{p.icon}</span>
          <span className={`text-sm font-semibold ${isSelected ? 'text-[#221C51]' : 'text-gray-700'}`}>
            {p.label}
          </span>
          {isSelected && (
            <span className="text-[10px] font-bold bg-[#221C51] text-white px-2 py-0.5 rounded-full">
              Sélectionné
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default PlatformSelector;
